import { MILESTONES } from '../constants';
import type { Milestone } from '../types';

/** Fresh milestone list for scenario/sandbox starts (EC-11). */
export function createFreshMilestones(): Milestone[] {
  return MILESTONES.map((m) => ({ ...m, completed: false }));
}